export const emailVariables = [
    { name: 'Application name', value: '{ApplicationName}' },
    { name: 'Snooze time', value: '{SnoozeTime}' },
    { name: '', value: '', css: 'divider' },
    { name: 'Tag name', value: '{TagName}' },
    { name: 'Tag comment', value: '{TagComment}' },
    { name: 'Identifier name', value: '{IdentifierName}' },
    { name: 'Identifier comment', value: '{IdentifierComment}' },
    { name: 'Group name', value: '{GroupName}' },
    { name: 'Group comment', value: '{GroupComment}' },
    { name: '', value: '', css: 'divider' },
    { name: 'Current value', value: '{CurrentValue}' },
    { name: 'TimeStamp', value: '{TimeStamp}' },
    { name: 'UTC timeStamp', value: '{UtcTimeStamp}' },
    { name: 'TimeStamps', value: '{TimeStamps}' },
    { name: 'UTC timeStamps', value: '{UtcTimeStamps}' },
    { name: 'Value type', value: '{ValueType}' },
    { name: 'Unit', value: '{Unit}' }
];

export const alarmVariables= [
    { name: 'Alarm severity', value: '{AlarmSeverity}' },
    { name: 'Alarm limit', value: '{AlarmLimit}' },
    { name: 'Alarm action', value: '{AlarmAction}' },
    { name: 'Alarm deviation', value: '{AlarmDeviation}' },
    { name: 'Alarm COF', value: '{AlarmCof}' },
    { name: 'Alarm POF', value: '{AlarmPof}' },
    { name: 'Alarm weight', value: '{AlarmWeight}' }
];

export const approvalVariables = [
    { name: 'Approval level', value: '{GroupApprovalLevel}' },
    { name: 'Approval user', value: '{GroupApprovalUser}' },
    { name: 'Approval user first name', value: '{GroupApprovalUserFirstName}' },
    { name: 'Approval user last name', value: '{GroupApprovalUserLastName}' },
    { name: 'Approval user mail', value: '{GroupApprovalUserMail}' },
    { name: 'Approval user phone', value: '{GroupApprovalUserPhone}' },
    { name: 'Approval comment', value: '{GroupApprovalRejectionCause}' }
];

export const ticketVariables = [
    { name: 'Creator name', value: '{TicketCreatorName}' },
    { name: 'Creator company', value: '{TicketCreatorCompany}' },
    { name: 'Assignee name', value: '{TicketAssigneeName} ' },
    { name: 'Assignee company', value: '{TicketAssigneeCompany}' },
    { name: 'Title', value: '{TicketTitle}' },
    { name: 'Description', value: '{TicketDescription}' },
    { name: 'Due date', value: '{TicketDueDate}' },
    { name: 'Modifier', value: '{TicketModifier}' },
    { name: 'Status', value: '{TicketStatus}' },
    { name: 'Justification', value: '{TicketJustification}' }
];